import { useState } from 'react';
import PropTypes from 'prop-types';

const ThirdPartyScriptsWrapper = ({
  children,
  shouldBlockThirdPartyScripts,
  thirdPartyScriptsRestrictedPages,
  router,
}) => {
  const [scriptsAlreadyLoaded, setScriptsAlreadyLoaded] = useState(false);
  const areScriptsRestrictedForCurrentPage = thirdPartyScriptsRestrictedPages.includes(router.location.pathname);

  if (!shouldBlockThirdPartyScripts) {
    return children;
  }

  if (areScriptsRestrictedForCurrentPage) {
    if (scriptsAlreadyLoaded) {
      // If scripts are already added to the page, we need to perform refresh to remove them
      window.location.reload();
    }

    return null;
  }

  if (!scriptsAlreadyLoaded) {
    setScriptsAlreadyLoaded(true);
  }

  return children;
};

ThirdPartyScriptsWrapper.propTypes = {
  shouldBlockThirdPartyScripts: PropTypes.bool,
  thirdPartyScriptsRestrictedPages: PropTypes.arrayOf(PropTypes.string),
};

ThirdPartyScriptsWrapper.defaultProps = {
  thirdPartyScriptsRestrictedPages: [],
};

export default ThirdPartyScriptsWrapper;
